import { create } from 'zustand';

interface WebRtcStats {
  clientJitterMs: number;
  clientPacketLossPercent: number;
  /** NACKs sent per packet received over the stats window, in % of total; undefined until known. */
  clientNackPercent?: number;
  /** PLIs (keyframe requests) sent over the stats window; undefined until known. */
  clientPliCount?: number;
  transport?: 'udp' | 'tcp';
}

interface WebRtcStatsStore {
  stats: Record<string, WebRtcStats>;
  setStats: (streamUri: string, stats: WebRtcStats) => void;
  removeStats: (streamUri: string) => void;
}

export const useWebRtcStatsStore = create<WebRtcStatsStore>(set => ({
  stats: {},
  setStats: (streamUri, newStats) =>
    set(state => {
      const prev = state.stats[streamUri];
      if (
        prev &&
        prev.clientJitterMs === newStats.clientJitterMs &&
        prev.clientPacketLossPercent === newStats.clientPacketLossPercent &&
        prev.clientNackPercent === newStats.clientNackPercent &&
        prev.clientPliCount === newStats.clientPliCount &&
        prev.transport === newStats.transport
      ) {
        return state;
      }
      return {
        stats: { ...state.stats, [streamUri]: newStats },
      };
    }),
  removeStats: streamUri =>
    set(state => {
      // eslint-disable-next-line
      const { [streamUri]: _, ...rest } = state.stats;
      return { stats: rest };
    }),
}));
